/*
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-07-14 10:23:41
 * @LastEditors: lwq
 * @LastEditTime: 2020-07-15 10:12:26
 * @FilePath: \mrc-base-server-view\src\store\index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
Vue.use(Vuex)

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
})
